import { render, staticRenderFns } from "./shopsTable.vue?vue&type=template&id=596527d8"
import script from "./shopsTable.vue?vue&type=script&lang=js"
export * from "./shopsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports